export default __webpack_public_path__ + "static/media/apx.0c0793fd.svg";